const userFilters = {
  firstName: null,
  lastName: null,
  active: true,
  securityRoles: null,
  employeePayrollTypeId: null,
  businessEntityId: null
}

export default () => Object.assign({}, userFilters)
